import React from 'react';
import { useState } from 'react';
import { useReducer } from 'react';
import { useMemo } from 'react';
import stringToNumArray from '../../../../../../utils/stringManipulation/StringToNumArray';

export const usePriceIntersectsFirstCandleEnabled = (tactic) => {
  const [
    priceIntersectsFirstCandleEnabled,
    setPriceIntersectsFirstCandleEnabled,
  ] = useState(tactic !== undefined);
  return [
    priceIntersectsFirstCandleEnabled,
    setPriceIntersectsFirstCandleEnabled,
  ];
};

export const useTimeOfDayEnabled = (tactic) => {
  const [timeOfDayEnabled, setTimeOfDayEnabled] = useState(
    tactic !== undefined
  );
  return [timeOfDayEnabled, setTimeOfDayEnabled];
};

export const useFtfcFilterEnabled = (tactic) => {
  const [ftfcFilterEnabled, setFtfcFilterEnabled] = useState(
    tactic !== undefined
  );
  return [ftfcFilterEnabled, setFtfcFilterEnabled];
};

export const useFtfcFilter = () => {
  const [ftfcFilter, dispatchFtfcFilter] = useReducer(
    (data, action) => ({ ...data, ...action }),
    { timeFrames: [] }
  );
  return [ftfcFilter, dispatchFtfcFilter];
};

export const usePriceIntersectsFirstCandle = () => {
  const [priceIntersectsFirstCandle, dispatchPriceIntersectsFirstCandle] =
    useReducer((data, action) => ({ ...data, ...action }), {
      candleDuration: 15,
      candleBarrier: '',
      direction: '',
    });
  return [priceIntersectsFirstCandle, dispatchPriceIntersectsFirstCandle];
};

export const useTimeOfDay = () => {
  const [timeOfDay, dispatchUseTimeOfDay] = useReducer(
    (data, action) => ({ ...data, ...action }),
    {
      startHour: 0,
      startMinute: 0,
      endHour: 0,
      endMinute: 0,
    }
  );
  return [timeOfDay, dispatchUseTimeOfDay];
};

export const useEmaIntersectsFirstCandleEnabled = (tactic) => {
  const [emaIntersectsFirstCandleEnabled, setEmaIntersectsFirstCandleEnabled] =
    useState(tactic !== undefined ? true : false);
  return [emaIntersectsFirstCandleEnabled, setEmaIntersectsFirstCandleEnabled];
};

export const useEmaIntersectsFirstCandle = () => {
  const [emaIntersectsFirstCandle, dispatchEmaIntersectsFirstCandle] =
    useReducer((data, action) => ({ ...data, ...action }), {
      firstCandleCandleDuration: 15,
      emaCandleDuration: 0,
      periodLengths: [],
      associatePerEmaSetup: false,
      candleBarrier: '',
      direction: '',
    });
  return [emaIntersectsFirstCandle, dispatchEmaIntersectsFirstCandle];
};

export function useSetupFilters(
  priceInserctsCandleEnabled,
  priceInserectsCandle,
  emaIntersectsFirstCandleEnable,
  emaIntersectsCandle,
  todEnabled,
  tod,
  ftfcEnabled,
  ftfc
  //positionsTacticsProcessor
) {
  const [
    priceIntersectsFirstCandleEnabled,
    setPriceIntersectsFirstCandleEnabled,
  ] = priceInserctsCandleEnabled;
  const [priceIntersectsFirstCandle, dispatchPriceIntersectsFirstCandle] =
    priceInserectsCandle;

  const [emaIntersectsFirstCandleEnabled, setEmaIntersectsFirstCandleEnabled] =
    emaIntersectsFirstCandleEnable;

  const [emaIntersectsFirstCandle, dispatchEmaIntersectsFirstCandle] =
    emaIntersectsCandle;

  const [timeOfDayEnabled, setTimeOfDayEnabled] = todEnabled;

  const [timeOfDay, setTimeOfDay] = tod;

  const [ftfcFilterEnabled, setFtfcFilterEnabled] = ftfcEnabled;
  const [ftfcFilter, setFtfcFilter] = ftfc;

  const setupFiltersProcessor = useMemo(
    () => ({
      priceIntersectsFirstCandle: {
        candleDuration: parseInt(priceIntersectsFirstCandle.candleDuration),
        candleBarrier: priceIntersectsFirstCandle.candleBarrier,
        direction: priceIntersectsFirstCandle.direction,
      },
      emaIntersectsFirstCandle: {
        firstCandleCandleDuration: parseInt(
          emaIntersectsFirstCandle.firstCandleCandleDuration
        ),
        emaCandleDuration: parseInt(emaIntersectsFirstCandle.emaCandleDuration),
        periodLengths: stringToNumArray(emaIntersectsFirstCandle.periodLengths),
        associatePerEmaSetup: emaIntersectsFirstCandle.associatePerEmaSetup,
        candleBarrier: emaIntersectsFirstCandle.candleBarrier,
        direction: emaIntersectsFirstCandle.direction,
      },
      timeOfDay: {
        startHour: parseInt(timeOfDay.startHour),
        startMinute: parseInt(timeOfDay.startMinute),
        endHour: parseInt(timeOfDay.endHour),
        endMinute: parseInt(timeOfDay.endMinute),
      },
      ftfcFilter: {
        timeFrames: ftfcFilter.timeFrames,
      },
    }),
    [
      priceIntersectsFirstCandle,
      emaIntersectsFirstCandle,
      timeOfDay,
      ftfcFilter,
    ]
  );

  const setupFilters = useMemo(
    () => ({
      ...(priceIntersectsFirstCandleEnabled && {
        PRICE_INTERSECTS_FIRST_CANDLE:
          setupFiltersProcessor.priceIntersectsFirstCandle,
      }),
      ...(emaIntersectsFirstCandleEnabled && {
        EMA_INTERSECTS_FIRST_CANDLE:
          setupFiltersProcessor.emaIntersectsFirstCandle,
      }),
      ...(timeOfDayEnabled && {
        TIME_OF_DAY: setupFiltersProcessor.timeOfDay,
      }),
      ...(ftfcFilterEnabled && {
        FTFC: setupFiltersProcessor.ftfcFilter,
      }),
    }),
    [
      setupFiltersProcessor,
      priceIntersectsFirstCandleEnabled,
      emaIntersectsFirstCandleEnabled,
      timeOfDayEnabled,
      ftfcFilterEnabled,
    ]
  );
  return setupFilters;
}
